export class ItemSortOption {
    Active: boolean;
    Name: string;
    Description: string;
    Fields: string[];
}
